import thunk from 'redux-thunk';
import logger from 'redux-logger';

export default [thunk, logger];



// WEBPACK FOOTER //
// ./src/middlewares.js